import { isCompleted, isSelected, isNumeric } from '../../../utils/Validation';
import * as commonConsts from '../../../pages/common/CommonConsts';

export const fundRaisingDetailValidatorRule = (props) => [
  {
    fieldName: 'charityObject',
    fieldValue: props.charityObject,
    isValid: (v) => isCompleted(v)
  },
  {
    fieldName: 'natureDuration',
    fieldValue: props.natureDuration,
    isValid: (v) => isCompleted(v)
  },
  {
    fieldName: 'directorRemuneration',
    fieldValue: props.directorRemuneration,
    isValid: (v) => {
      if (
        props.authorityInformation?.licenceInfo?.licenseeType?.toLowerCase() ===
        commonConsts.OptionsIndividual.toLowerCase()
      ) {
        return true;
      }

      return isSelected(v);
    }
  },
  {
    fieldName: 'applicantOrgType',
    fieldValue: props.applicantOrgType,
    isValid: (v) => {
      if (
        props.authorityInformation?.licenceInfo?.licenseeType?.toLowerCase() ===
        commonConsts.OptionsIndividual.toLowerCase()
      ) {
        return true;
      }

      return isSelected(v);
    }
  },
  {
    fieldName: 'day',
    fieldValue: props.day,
    isValid: (v) => {
      if (!isNumeric(v)) {
        return false;
      }

      if (v < 1) {
        return false;
      }

      if (isCompleted(props.month) && props.month === '02') {
        return v <= 29;
      } else {
        return v <= 31;
      }
    }
  },
  {
    fieldName: 'month',
    fieldValue: props.month,
    isValid: (v) => isCompleted(v)
  }
];
